import { useEffect, useMemo, useState } from 'react'
import { useBustBidList, useBustedGameActions, useBustedGameData } from '../useBustGameData'
import { BustedCardCSS } from './BustedCardCSS.styled'
import { useUser } from 'hooks/user/useUser'
import { ContentSwitcherByState } from 'components/Atoms/ContentSwitcherByState'
import { currencyFormatter } from 'utils'
import { useWalletConnection } from 'hooks/useWalletConnection'
import { onlyDigits } from 'utils/uiUtils_TS'

// const onlyDigits = (value) => {
//   let digits = value?.replace(/[^.\d]+/g, '')
//   if (digits && digits.match(/\./g)?.length > 1) digits = digits.substr(0, digits.lastIndexOf('.'))

//   return digits
// }

export const BustedCard = () => {
  const { account } = useUser('wallet')
  const { connectWallet, disconnectWallet } = useWalletConnection()

  const { state, currentMultiplier, betCounter } = useBustedGameData()
  const { myLiveBid } = useBustBidList()
  const placedBid = useMemo(() => myLiveBid.length > 0, [myLiveBid])
  const [amount, setAmount] = useState()
  const { placeBid, cashoutBid } = useBustedGameActions(false)

  const [buttonState, setButtonState] = useState('bid')
  useEffect(() => {
    if (!account) {
      setButtonState('login')
      return
    }
    if (placedBid === true && state === 'start') setButtonState('cashout')
    if (placedBid === false && state === 'start') setButtonState('disabled')
    if (placedBid === true && state === 'wait') setButtonState('disabled')
    if (placedBid === false && state === 'wait') setButtonState('bid')
    if (placedBid === false && state === 'crash') setButtonState('disabled')
    if (placedBid === true && state === 'crash') setButtonState('disabled')
  }, [state, placedBid, account])

  const onBidClick = () => {
    if (buttonState === 'bid') placeBid(amount)
    if (buttonState === 'cashout') {
      cashoutBid()
      setButtonState('disabled')
    }
  }

  const onSignInClick = () => {
    connectWallet()
  }

  const onAmountChange = (e) => {
    const value = e.target.value
    const amount = onlyDigits(value)
    setAmount(amount)
  }

  return (
    <BustedCardCSS>
      <>
        {/* <!-- GAME --> */}

        <section>
          <div className='row subtitle'>Bid Amount</div>
          <div className='row bid_amount_field'>
            <input type='text' placeholder='0.00' value={amount} onChange={onAmountChange} />
          </div>
          <br />
          <div className='row'>
            <div className='bidding_buttons busted'>
              <ContentSwitcherByState
                noWrapper
                activeState={buttonState}
                stateObject={{
                  login: (
                    <button
                      type='button'
                      className='login'
                      onClick={onSignInClick}
                      disabled={buttonState === 'disabled'}
                    >
                      <strong>SIGN IN TO PLAY</strong>
                    </button>
                  ),
                  cashout: (
                    <button className='cashout' onClick={onBidClick}>
                      Cash out
                      <div className='pandl_ind'>
                        <span>{currencyFormatter(currentMultiplier * (myLiveBid.at(0)?.bidAmount || 0))}</span>
                        <span className='divider'>|</span>
                        <span>
                          {currencyFormatter(currentMultiplier, {
                            noCurrencySign: true,
                          })}
                        </span>
                      </div>
                    </button>
                  ),
                  default: (
                    <button type='button' className='timer' onClick={onBidClick} disabled={buttonState === 'disabled'}>
                      <strong>BID NOW</strong>
                      <span>Starts in {currencyFormatter(betCounter, { noCurrencySign: true })}</span>
                    </button>
                  ),
                }}
              />
            </div>
          </div>
        </section>
      </>
    </BustedCardCSS>
  )
}
